export default __webpack_public_path__ + "static/discordScreenshot@2x-52478fd54c53b78e3905b3626758373a.png";